import clsx from 'clsx';

export function InfoBlock({ className, children }) {
  return <div className={clsx('mt-5 pt-5 border-t border-solid', className)}>{children}</div>;
}
